import cookies from '@buzzfeed/bf-utils/lib/cookies';

const BOOKMARKS_ME_BUZZ_PATH = '/bookmarks-api/v1/me/buzz';

export async function getBuzzBookmarkStatus(buzzId) {
  try {
    const response = await fetch(`${BOOKMARKS_ME_BUZZ_PATH}/${buzzId}`, {
      credentials: 'include',
      headers: {
        'X-XSRF': cookies.get('_xsrf'),
      },
    });
    return { status: response.status, ok: response.ok };
  } catch (error) {
    console.error('Error getting post bookmark status', error);
    return { ok: false };
  }
}

export async function setBuzzBookmarkStatus({ buzzId, action }) {
  try {
    const response = await fetch(`${BOOKMARKS_ME_BUZZ_PATH}/${buzzId}`, {
      method: action,
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF': cookies.get('_xsrf'),
      },
    });
    return { status: response.status, ok: response.status === 204 };
  } catch (error) {
    console.log(error);
    console.log("Error: getting post bookmark status");
    return { ok: false };
  }
}

